module.exports = __webpack_public_path__ + "img/logo-small.a613804f.png";